import React from 'react';
import useDocumentTitle from '../../../hooks/useDocumentTitle';
import { Box, Stack, Tab, Tabs } from '@mui/material';
import useDocumentFilters from '../../../components/filters/DocumentFilterHelper';
import ProformaInvoiceTable from '../components/ProformaInvoiceTable';
import TopBar from '../../../components/TopBar';
import ProformaInvoiceListPageActions from '../components/ProformaInvoiceListPageAction';
import ProformaInvoiceListFilters from '../components/ProformaInvoiceListFilters';
import { useTranslatedMessages } from '../../../hooks/useTranslatedMessages';

function ProformaInvoiceListPage() {
  const { proformaInvoices: pi } = useTranslatedMessages();
  const listPage = pi?.pages?.list ?? {};
  const placeholders = listPage?.filters?.placeholders ?? {};

  useDocumentTitle(listPage?.document_title ?? 'Proforma Invoice List');

  const filters = [
    {
      type: 'search',
      options: [
        { key: 'document_number', placeholder: placeholders?.proforma_invoice_no ?? 'Proforma Invoice No' },
        { key: 'billed_to_name', placeholder: placeholders?.buyer_name ?? 'Buyer Name' },
        { key: 'billed_to_vat', placeholder: placeholders?.buyer_vat ?? 'Buyer VAT' },
        { key: 'billed_by_name', placeholder: placeholders?.seller_name ?? 'Seller Name' },
        { key: 'billed_by_vat', placeholder: placeholders?.seller_vat ?? 'Seller VAT' },
      ],
    },
  ];

  const {
    selectedFilter,
    searchTerm,
    currentQuery,
    selectedStatus,
    dateRange,
    handleFilterChange,
    handleSearchChange,
    handleSearchKeyPress,
    handleStatusChange,
    handleDateRangeChange,
    handlePaginationChange,
  } = useDocumentFilters({
    defaultQuery: {},
    searchOnChange: true,
    persistKey: 'sales/proforma-invoices',
  });

  return (
    <Stack direction="column" spacing={3}>
      <TopBar title={listPage?.top_bar_title ?? 'Proforma Invoice List'} />
      <Box display="flex" justifyContent="end" alignItems="center">
        <Stack direction="row" spacing={1}>
          <ProformaInvoiceListPageActions />
        </Stack>
      </Box>
      <Box>
        <Stack direction="column" sx={{ mt: '-1rem' }}>
          <Box mb={2}>
            <ProformaInvoiceListFilters
              filters={filters}
              selectedFilter={selectedFilter}
              onFilterChange={handleFilterChange}
              searchTerm={searchTerm}
              onSearchChange={handleSearchChange}
              onSearchKeyPress={handleSearchKeyPress}
              selectedStatus={selectedStatus}
              onStatusChange={handleStatusChange}
              dateRange={dateRange}
              onDateRangeChange={handleDateRangeChange}
            />
          </Box>
          <ProformaInvoiceTable handlePaginationChange={handlePaginationChange} searchQuery={currentQuery} />
        </Stack>
      </Box>
    </Stack>
  );
}

export default ProformaInvoiceListPage;
